import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import SVG from 'react-inlinesvg';
import Steps, { Step } from 'rc-steps';
import { putRequest } from '../../../requestUtils';
import { analyticsTrack } from '../../../analyticsUtils';
import alertTriangle from '../../../../assets/images/alert-triangle.svg';
import AddCoworkersModal from '../../AddCoworkersModal';
import './NextSteps.scss';
import RegistrationModal from '../../RegistrationModal';

const proposalTabLinks = [
  'Click "Hire" on the best proposal to begin working with your consultant',
  'Review proposals & choose who to interview',
];
const titleMapping = {
  'Onboarding Guide': 'onboarding_guide',
  'Timesheet Tips': 'timesheet_tips',
  'Extend the contract / Hire again': 'extend_contract_or_hire_again',
  'Offboarding Guide': 'offboarding_guide',
  'Schedule a call to expedite matching': 'scoping_call',
};
const recommendationTabLinks = ['Browse & connect with talent'];
const collaboratorsModal = ['Invite collaborators'];
const screeningQuestion = ['Add screening questions for applicants to answer'];

const cssClass = (projectStatus, item, nextStep) => {
  if (projectStatus === 'clora_matched') {
    return 'rc-steps-agreement-status';
  } if (nextStep && item.step === nextStep.step) {
    return 'rc-steps-item-process';
  }

  return '';
};

const setStepStatus = (currentStep, item) => {
  if (currentStep === item.step) {
    return 'process';
  }

  return item.completed ? 'finish' : 'wait';
};

class NextSteps extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    // Check if nextStepsData prop has changed
    if (nextProps.nextStepsData !== prevState.prevNextStepsData) {
      // Return new state object to update nextSteps
      // and Store the current nextStepsData prop for comparison
      return {
        nextSteps: nextProps.nextStepsData.next_steps,
        prevNextStepsData: nextProps.nextStepsData,
      };
    }
    return null; // No state update necessary
  }

  constructor(props) {
    super(props);
    const { nextStepsData } = props;
    const nextStep = nextStepsData.next_steps.find((item) => item.completed === false);
    this.state = {
      prevNextStepsData: nextStepsData,
      currentStep: null,
      nextSteps: nextStepsData.next_steps || [],
      nextStep: nextStep || null,
      projectStatus: nextStepsData.project_status,
      resourceId: nextStepsData.resource_id,
      showAddCoworkerModal: false,
      showRegistrationModal: false,
    };

    this.handleOnChange = this.handleOnChange.bind(this);
    this.renderNextSteps = this.renderNextSteps.bind(this);
    this.toggleRegistrationModal = this.toggleRegistrationModal.bind(this);
  }

  handleOnChange(currentStep) {
    const { nextSteps } = this.state;
    const {
      clickTab, salesBookingLink, userSignedIn, location,
    } = this.props;
    if (userSignedIn) {
      const clickedItem = nextSteps.find((item) => item.step === currentStep);
      if (recommendationTabLinks.includes(clickedItem.title)) {
        clickTab('Recommended Consultants');
      } else if (proposalTabLinks.includes(clickedItem.title)) {
        clickTab('Proposals');
      } else if (['Submit your project', 'Tell us how the interview went'].includes(clickedItem.title)) {
        window.location.href = clickedItem.link_url;
      } else if (Object.keys(titleMapping).includes(clickedItem.title)) {
        window.open(
          clickedItem.title === 'Schedule a call to expedite matching'
            ? salesBookingLink : clickedItem.link_url,
          '_blank',
        );
        this.handleUpdate(clickedItem);
      } else if (collaboratorsModal.includes(clickedItem.title)) {
        this.setState({ showAddCoworkerModal: true });
      } else if (screeningQuestion.includes(clickedItem.title)) {
        clickTab('Screening Questions');
      }

      this.setState({ currentStep, nextStep: null });
    } else {
      this.toggleRegistrationModal();
      analyticsTrack('Clicked on next steps CTA', { location });
      analyticsTrack('Opened registration modal', { location });
    }
  }

  handleUpdate(clickedItem) {
    const { resourceId } = this.state;
    const { csrfToken } = this.props;
    putRequest(
      `/projects/${resourceId}/update_next_steps`,
      { action_clicked: titleMapping[clickedItem.title] },
      csrfToken,
    ).then(({ data }) => {
      this.setState({
        nextSteps: data.next_steps,
        currentStep: null,
        nextStep: data.next_steps.find((item) => item.completed === false),
      });
    });
  }

  toggleRegistrationModal() {
    this.setState((prev) => ({
      showRegistrationModal: !prev.showRegistrationModal,
    }));
  }

  renderNextSteps() {
    const {
      nextSteps, currentStep, projectStatus, nextStep, userSignedIn,
    } = this.state;
    return (
      <Fragment>
        {
          nextSteps.map((item) => (
            <Step
              stepIndex={item.step}
              title={item.title}
              status={setStepStatus(currentStep, item)}
              className={cssClass(projectStatus, item, nextStep)}
              disabled={userSignedIn && item.completed}
              onStepClick={this.handleOnChange}
            />
          ))
        }
      </Fragment>
    );
  }

  render() {
    const {
      currentStep, showAddCoworkerModal, showRegistrationModal,
    } = this.state;
    const {
      csrfToken,
      initialTeamMembers,
      editableRoles,
      basePermissionsUrl,
      invitableRoles,
      googleOmniauthUrl,
      msOmniauthUrl,
      signInUrl,
      location,
      inviterId,
      projectResourceId,
    } = this.props;

    return (
      <div className="items-list-container">
        <div className="header-container">
          <h3>Next Steps</h3>
          <SVG src={alertTriangle} title="Project next steps" />
        </div>
        <div className="items-container">
          <Steps
            direction="vertical"
            current={currentStep}
          >
            {this.renderNextSteps()}
          </Steps>
        </div>
        <AddCoworkersModal
          csrfToken={csrfToken}
          initialTeamMembers={initialTeamMembers}
          invitableRoles={invitableRoles}
          editableRoles={editableRoles}
          basePermissionsUrl={basePermissionsUrl}
          location="next-steps-component"
          showModalCallback={() => { this.setState({ showAddCoworkerModal: false }); }}
          modalIsOpen={showAddCoworkerModal}
        />
        <RegistrationModal
          csrfToken={csrfToken}
          showModal={showRegistrationModal}
          hideModal={this.toggleRegistrationModal}
          googleOmniauthUrl={googleOmniauthUrl}
          msOmniauthUrl={msOmniauthUrl}
          signInUrl={signInUrl}
          showTestimonials={false}
          location={location}
          inviterId={inviterId}
          projectResourceId={projectResourceId}
        />
      </div>
    );
  }
}

NextSteps.propTypes = {
  clickTab: PropTypes.func,
  nextStepsData: PropTypes.shape({}),
  csrfToken: PropTypes.string.isRequired,
  initialTeamMembers: PropTypes.shape({}),
  invitableRoles: PropTypes.arrayOf(PropTypes.string),
  editableRoles: PropTypes.arrayOf(PropTypes.string),
  basePermissionsUrl: PropTypes.string.isRequired,
  salesBookingLink: PropTypes.string,
  googleOmniauthUrl: PropTypes.string.isRequired,
  msOmniauthUrl: PropTypes.string.isRequired,
  signInUrl: PropTypes.string.isRequired,
  userSignedIn: PropTypes.bool,
  location: PropTypes.string,
  inviterId: PropTypes.string,
  projectResourceId: PropTypes.string,
};

NextSteps.defaultProps = {
  nextStepsData: {},
  clickTab: () => {},
  initialTeamMembers: { current_user_permission: null, team_members: [] },
  invitableRoles: [],
  editableRoles: [],
  salesBookingLink: null,
  userSignedIn: true,
  location: 'Projects view',
  inviterId: null,
  projectResourceId: null,
};

export default NextSteps;
